// Capitalize only the first letter of a string .
export function capitalize (s: string | undefined): string {
  if (typeof s !== 'string') {
    return ''
  }
  s = s.toLowerCase()
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default { capitalize }
